export default __webpack_public_path__ + "static/media/small Orange.1342e658.png";